import { $ReadOnly } from 'utility-types';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { ORG_TYPES } from './orgTypes';

export const ORG_TYPES_ALLOW_TO_POST_VOLOPS: ReadonlyArray<
  $ReadOnly<{
    id: string;
    name: string;
  }>
> = ORG_TYPES.filter((type) => ['NONPROFIT', 'GOVERNMENT'].includes(type.id));
